import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import type { DashboardInvitations } from '../types/dashboard';

interface Props {
  invitations: DashboardInvitations;
  invitesPath: string;
}

const OutgoingInvitationsCard: React.FC<Props> = ({ invitations, invitesPath }) => {
  const total = invitations.pending + invitations.expired_pending;

  if (total === 0 && invitations.expiring_within_7_days === 0) {
    return null;
  }

  return (
    <Card className="ntcog-card dashboard-section-card dashboard-invitations-card">
      <Card.Header className="d-flex align-items-start justify-content-between gap-2">
        <div>
          <div>Invitations you sent</div>
          <small className="text-muted fw-normal d-block">People who have not joined yet</small>
        </div>
        <Link to={invitesPath} className="small text-decoration-none flex-shrink-0">
          Manage
        </Link>
      </Card.Header>
      <Card.Body className="p-0">
        <ul className="list-unstyled mb-0">
          <li className="dashboard-invitations-row">
            <span>Waiting for a reply</span>
            <span className="fw-semibold">{invitations.pending}</span>
          </li>
          <li className="dashboard-invitations-row">
            <span>Expiring within 7 days</span>
            <span className="fw-semibold">{invitations.expiring_within_7_days}</span>
          </li>
          <li className="dashboard-invitations-row">
            <span>Expired</span>
            <span className="d-flex align-items-center gap-3">
              <span className="fw-semibold">{invitations.expired_pending}</span>
              {invitations.expired_pending > 0 ? (
                <Link to={invitesPath} className="small text-decoration-none">
                  Resend
                </Link>
              ) : null}
            </span>
          </li>
        </ul>
      </Card.Body>
    </Card>
  );
};

export default OutgoingInvitationsCard;
